<div class="check-box">
    <i *ngIf="!isChecked" class="pi pi-circle-off" style="color: #6c757d; font-size: 2.5rem"></i>
    <i *ngIf="isChecked" class="pi pi-check-circle" style="color: #6ca970; font-size: 2.5rem"></i>
</div>
